import { useState } from 'react';

function SearchableDropdown({ 
  options, 
  label, 
  name, 
  selectedValue, 
  onChange 
}) {
  const [searchQuery, setSearchQuery] = useState('');

  // Filter options based on search query
  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="form-control col-span-1">
      <label htmlFor={name}>
        <span className="label-text">{label}</span>
      </label>
      
      {/* Search Input */}
      <input
        type="text"
        placeholder={`Search ${label}`}
        className="input input-bordered w-full mb-2"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      
      <select
        name={name}
        id={name}
        className="select select-bordered w-full"
        onChange={onChange}
        value={selectedValue || ''}
      >
        <option key="" value="">Select an Option</option>

        {filteredOptions.map((option) => (
          <option key={option.id} value={option.id}>{option.name}</option>
        ))}
      </select>
    </div>
  );
}

export default SearchableDropdown;
